<div class="container-viewport">

  <!-- Welcome Banner -->
  <div class="welcome-banner">
    <div class="banner-content">
      <h3>New to EASiHub?</h3>
      <p>The premier platform connecting enterprise application professionals worldwide</p>
    </div>
    <div class="banner-actions">
      <a href="https://easihub.com/community" class="banner-cta secondary">
        <fa-icon [icon]="icons.faUsers"></fa-icon>
        Join Community
      </a>
      <a href="https://easihub.com/community/get-started" class="banner-cta primary">
        Get Started <fa-icon [icon]="icons.faArrowRight"></fa-icon>

      </a>
    </div>
  </div>

  <!-- Community Quick-Links Bar -->
  <div class="community-quicklinks-bar">
    <div class="community-bar-header">
      <h5>
        <fa-icon [icon]="icons.faUsers"></fa-icon>
        Community
      </h5>
    </div>
    <div class="community-links">
      @for (link of communityLinks; track link.link) {
      <a [href]="link.link" class="community-link" [class.primary]="link.primary">
        <fa-icon [icon]="link.icon"></fa-icon>
        {{ link.text }}
      </a>
      }
    </div>
  </div>

  <!-- Main Footer Grid -->
  <div class="footer-grid">

    <!-- Brand Section -->
    <div class="brand-section surface glass">
      <div class="brand-header">
        <img src="/assets/brand/logo-full-dark.png" alt="EASiHub">
      </div>
      <p class="brand-tagline">The enterprise application platform ecosystem</p>
      <p class="brand-description">
        Where enterprise application expertise meets opportunity. Connect with the professionals shaping how business gets done—from implementation to innovation across <strong>the world's most critical business systems.</strong>
      </p>

      <div class="social-links">
        @for (social of socialLinks; track social.href) {
        <a [href]="social.href" [attr.aria-label]="social.label">
          <fa-icon [icon]="social.icon"></fa-icon>
        </a>
        }
      </div>
    </div>

    <!-- Platform Section -->
    <div class="footer-menu surface glass">
      <div class="footer-column">
        <h4>
          <fa-icon [icon]="icons.faCube"></fa-icon>
          Platform
        </h4>
        <ul>
          @for (link of platformLinks; track link.link) {
          <li>
            <a [routerLink]="link.link" [class.primary]="link.primary">
              <fa-icon [icon]="link.icon"></fa-icon>
              {{ link.text }}
            </a>
          </li>
          }
        </ul>
      </div>
    </div>

    <!-- Company Section -->
    <div class="footer-menu surface glass">
      <div class="footer-column">
        <h4>
          <fa-icon [icon]="icons.faBuilding"></fa-icon>
          Company
        </h4>
        <ul>
          @for (link of companyLinks; track link.link) {
          <li>
            <a [routerLink]="link.link">
              <fa-icon [icon]="link.icon"></fa-icon>
              {{ link.text }}
            </a>
          </li>
          }
        </ul>
      </div>
    </div>

    <!-- Resources Section -->
    <div class="footer-menu surface glass">
      <div class="footer-column">
        <h4>
          <fa-icon [icon]="icons.faBook"></fa-icon>
          Resources
        </h4>
        <ul>
          @for (link of resourcesLinks; track link.link) {
          <li>
            <a [routerLink]="link.link">
              <fa-icon [icon]="link.icon"></fa-icon>
              {{ link.text }}
            </a>
          </li>
          }
        </ul>
      </div>
    </div>

  </div>

  <!-- Contact Bar -->
  <div class="contact-bar">
    <div class="contact-content">
      <h4 class="contact-heading">
        <fa-icon [icon]="icons.faHeadset"></fa-icon>
        Get In Touch
      </h4>
      <div class="contact-items">
        @for (contact of contactItems; track contact.href) {
        <div class="contact-item">
          <fa-icon [icon]="contact.icon"></fa-icon>
          <a [href]="contact.href">{{ contact.text }}</a>
        </div>
        }
      </div>
    </div>
    <div class="contact-social">
      <h5>Follow Us</h5>
      <div class="social-platforms">
        @for (social of socialPlatforms; track social.href) {
        <a [href]="social.href" [attr.aria-label]="social.label">
          <fa-icon [icon]="social.icon"></fa-icon>
        </a>
        }
      </div>
    </div>
  </div>

  <!-- Footer Bottom -->
  <div class="footer-bottom">
    <div class="copyright">
      © {{currentYear}} EASiHub <br>
      Built for Enterprise Application Software (EAS) Professionals
    </div>
    <div class="legal-links">
      <a routerLink="/legal/privacy-policy">Privacy Policy</a>
      <a routerLink="/legal/master-terms-of-service">Terms of Service</a>
      <a routerLink="#">Code of Conduct</a>
      <a routerLink="/legal/cookie-policy">Cookie Policy</a>
    </div>
  </div>
</div>